import { useTranslatable } from 'src/hooks/locale/utils'
import Warning from 'src/imgs/classroom_icon.svg'
import NoContent from 'src/views/components/NoContent'

interface Props {
  readonly title: string
}

export default function AdministratorCoursePlaceholderPage({ title }: Props): JSX.Element {
  const t = useTranslatable()
  return (
    <NoContent
      header={title}
      subHeader={t(['common:under_construction', 'Under Construction'])}
      image={Warning}
      marginTop="5"
    />
  )
}
